import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { convertFormatFromApiToJs, convertFormatFromApiToMoment } from "../actions/conversions";
import { COMMON_STATUS } from "../constants/status";
import { ITenantInfo } from "../interface/ITenant";
import TenantService from "../service/TenantService";
import { RootState } from "../store/store";
import { logoutUser } from "./common";


export const resetTenant = createAction("tenant/reset")

const _service = new TenantService();

type SliceState = { value: ITenantInfo ,status:string ,apiCallCount:number} 

const initialState = {
  value: {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount:0
}as SliceState;

export const getTenantAsync = createAsyncThunk(
  "tenant/getTenant",
  async (params:string) => {
    const response = await _service.getTenantService(params);
    return response;
  }
);


export const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenantStatus: (state,action) => {
      state.status=action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTenantAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getTenantAsync.fulfilled, (state, action) => {
        const dtJs = convertFormatFromApiToJs(action.payload.dateFormat);
        action.payload.dateJs = dtJs;

        const dtMoment = convertFormatFromApiToMoment(action.payload.dateFormat);
        action.payload.dtMoment = dtMoment;

        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getTenantAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetTenant, () => {
        return initialState;
      });
  },
});

export const {setTenantStatus} = tenantSlice.actions;
export const getTenantInfo = (state:RootState) => state.tenant.value;
export const getTenantLoadingStatus = (state:RootState) => state.tenant.status;
export const getTenantDateJs = (state:RootState) => state.tenant.value.dateJs;
export const getTenantDateMoment = (state:RootState) => state.tenant.value.dtMoment;
export const getCurrency = (state:RootState) => state.tenant.value.currency;
export const getDecimalPlaces = (state:RootState) => state.tenant.value.decimalPlacesPrice || 2;
export const getDecimalSeparator = (state:RootState) => state.tenant.value.numberDecimalSeparator || '.';
export const getThousand  = (state:RootState) => state.tenant.value.numberDecimalSeparator &&  state.tenant.value.numberDecimalSeparator =='.'?",":".";
export const getTenantMininum = (state:RootState) => state.tenant.value.minOrder;
export const getTenantApplyMinOrderCart = (state:RootState) => state.tenant.value.applyMinOrderCart;
export default tenantSlice.reducer;